/*
* @Author: 曹俊杰
* @Date: 2022-05-10 17:52:49
* @Module: 智库
*/
<template>
  <div class="thinktank">
      <div class="left">
          <listMenu v-for="item in menuList" :itemData="item" :key="item.name" pathPrefix="thinktank"/>
      </div>
      <div class="right">
          <keep-alive>
              <router-view />
          </keep-alive>
      </div>
  </div>
</template>
<script>
import listMenu from '@/components/listMenu/listMenu.vue';
export default {
  components: {
      listMenu
  },
  data() {
    return {
      menuList: [
        {
          title: '合同模版',
          name: 'thinktankList',
          icon: 'el-icon-ali-hetongmoban'
        },
        {
          title: '我的购买',
          name: 'thinktankMy',
          icon: 'el-icon-ali-wodegoumai',
          authority: []
        }
      ]
    };
  },
}
</script>
<style lang='scss' scoped>
.thinktank {
  @include contentStyle2;
}
</style>